module.exports = __webpack_public_path__ + "img/Vietnam-hover.8d24ac25.jpg";